const pvzByIds = {};

const addPvzInfo = (id, info) => {
    if (pvzByIds[id]) {
        return;
    }
    pvzByIds[id] = info;
}

const getPvzById = async (id) => {
    if (!pvzByIds[id]) {
        await loadPvzs([id]);
    }
    return pvzByIds[id] ?? {};
};

const getMapCoords = async () => {
    const apiResult = await fetch(`/api/city/current/`);
    if (apiResult.status !== 200) {
        // default Moscow, but maybe we should return error code
        return { lat: 55.752491072272264, long: 37.61567497253408, zoom: 11 };
    }
    return await apiResult.json();
};

const loadPvzs = async (pvzIdList = []) => {
    const apiResult = await fetch(`/api/pvzs/?ids=${pvzIdList.join()}`);
    if (apiResult.status !== 200) {
        // don't add anything if request fails
        return;
    }
    const data = await apiResult.json();
    Object.values(data).forEach((pvz) => {
        const { id } = pvz;
        addPvzInfo(id, pvz);
    });
};

const getMapData = async (current = '', pvzIdList = [], type = 'pvz') => {
    const apiResult = await fetch(`/api/pvzs/map/?ids=${pvzIdList.join()}&current=${current}&button=${window.showBtn ? 1 : 0}&type=${type}&contacts=${window.isContacts ? 1 : 0}`);
    if (apiResult.status !== 200) {
        return { type: "FeatureCollection", features: [] };
    }
    return await apiResult.json();
};

// add autoload
document.addEventListener('DOMContentLoaded', async () => {
    const { map_latitude, map_longitude, map_zoom } = await getMapCoords();
    await loadPvzs(window.pvzNeeded ?? []);
    const pvzMapData = await getMapData(window.pvzCurrent ?? '',window.pvzList ?? [], 'pvz');
    const posMapData = await getMapData(window.posCurrent ?? '', window.posList ?? [], 'pos')

    const templatesByPlace = {
        '[data-button-select-pvz]' : (pvz, element) => {
            element.attr('data-id', pvz.id);
            element.data('id', pvz.id);
            if (Number(window.pvzCurrent) === Number(pvz.id)) {
                element.prop('disabled', true);
                return `<span>Выбран</span>`;
            }
            element.prop('disabled', false);
            return `<span>Выбрать</span>`;
        },
        '[data-button-select-pos]' : (pvz, element) => {
            element.attr('data-id', pvz.id);
            element.data('id', pvz.id);
            if (Number(window.posCurrent) === Number(pvz.id)) {
                element.prop('disabled', true);
                return `<span>Выбран</span>`;
            }
            element.prop('disabled', false);
            return `<span>Выбрать</span>`;
        },
    };

    $('body').on('click', '[data-button-select-pvz]:enabled', (e) => {
        const btn = $(e.target).closest('div').find('button');
        const id = btn.data('id');
        btn.prop('disabled', true);
        btn.html('<img class="loader" src="/assets/images/loader.gif">');
        window.additionalPlaces = { '[data-button-select-pvz]': templatesByPlace['[data-button-select-pvz]'] };
        $(`[data-pvz-id="${id}`).trigger('click');
    });
    $('body').on('click', '[data-button-select-pos]:enabled', (e) => {
        const btn = $(e.target).closest('div').find('button');
        const id = btn.data('id');
        btn.prop('disabled', true);
        btn.html('<img class="loader" src="/assets/images/loader.gif">');
        window.additionalPlaces = { '[data-button-select-pos]': templatesByPlace['[data-button-select-pos]'] };
        $(`[data-pvz-id="${id}`).trigger('click');
    });
    $('body').on('change', '[data-contacts-pvz]', (e) => {
        const id = $(e.target).val();
        window.objectManager.objects.balloon.open(id);
        window.updatePvzMap(id);
    });
    window.ymaps?.ready(function () {
        if ($('#pvz-map').length > 0) {
            window.pvzMap = new window.ymaps.Map('pvz-map', {
                center: [map_latitude, map_longitude],
                zoom: map_zoom,
                controls: ['zoomControl', 'fullscreenControl']
            }, {
                searchControlProvider: 'yandex#search'
            });
            window.objectManager = new ymaps.ObjectManager();
            window.objectManager.add(pvzMapData);
            if (window.isContacts) {
                window.objectManager.add(posMapData);
            }
            window.pvzMap.geoObjects.add(window.objectManager);
            window.objectManager.objects.events.add('click', (e) => {
                const objectId = e.get('objectId');
                window.updatePvzMap(objectId, templatesByPlace);
                if (window.isContacts) {
                    $(`.pickpoint-radio[data-pvz-id=${objectId}]`).trigger('click');
                }
            });
            window.objectManager.objects.balloon.events.add('open', (e) => {
                const element = $('[data-button-select-pvz]');
                const objectId = e.get('objectId');
                element.attr('data-id', objectId);
                element.data('id', objectId);
                if (Number(window.pvzCurrent) === Number(objectId)) {
                    element.prop('disabled', true);
                    element.html(`<span>Выбран</span>`);
                    return;
                }
                element.prop('disabled', false);
                element.html(`<span>Выбрать</span>`);
            });

            if (window.pvzCurrent) {
                window.objectManager.objects.balloon.open(window.pvzCurrent);
            }
            window.pvzMap.behaviors.disable('scrollZoom');
            if(Math.max($(window).width(), window.innerWidth) < 750) {
                window.pvzMap.behaviors.disable('drag');
            }
        }

        if ($('#pos-map').length > 0) {
            window.posMap = new window.ymaps.Map('pos-map', {
                center: [map_latitude, map_longitude],
                zoom: map_zoom,
                controls: ['zoomControl', 'fullscreenControl']
            }, {
                searchControlProvider: 'yandex#search'
            });
            window.posObjectManager = new ymaps.ObjectManager();
            window.posObjectManager.add(posMapData);
            window.posMap.geoObjects.add(window.posObjectManager);
            window.posObjectManager.objects.events.add('click', (e) => {
                const objectId = e.get('objectId');
                window.updatePvzMap(objectId, templatesByPlace, window.posObjectManager);
            });
            window.posObjectManager.objects.balloon.events.add('open', (e) => {
                const element = $('[data-button-select-pos]');
                const objectId = e.get('objectId');
                element.attr('data-id', objectId);
                element.data('id', objectId);
                if (Number(window.posCurrent) === Number(objectId)) {
                    element.prop('disabled', true);
                    element.html(`<span>Выбран</span>`);
                    return;
                }
                element.prop('disabled', false);
                element.html(`<span>Выбрать</span>`);
            });

            if (window.posCurrent) {
                window.posObjectManager.objects.balloon.open(window.posCurrent);
            }
            window.posMap.behaviors.disable('scrollZoom');
            if(Math.max($(window).width(), window.innerWidth) < 750) {
                window.posMap.behaviors.disable('drag');
            }
        }
    });
});

// почти модули, вместо export - глобальная переменная
window.updatePvzMap = async (pvzId, elementsToUpdate = {}, manager = window.objectManager) => {
    const pvzInfo = await getPvzById(pvzId);
    Object.entries(elementsToUpdate).forEach(([selector, templateFn]) => $(selector).html(templateFn(pvzInfo, $(selector))));
    const state = manager.getObjectState(pvzId);
    if (state.found) {
        manager.objects.each((object) => {
            manager.objects.setObjectOptions(object.id, { preset: 'islands#blueIcon' });
        })
        manager.objects.setObjectOptions(pvzId, { preset: 'islands#redIcon' });
    }
};
